<script module lang="ts">
  import type { Props as BoxProps } from './Box.svelte';

  export type Props = Omit<BoxProps, 'state'>;
</script>

<script lang="ts">
  import type { Snippet } from 'svelte';
  import Box from './Box.svelte';

  const { children, ...toNext }: Props = $props();

  // -
  const renderChildren = $derived(children) as Snippet | undefined;
</script>

<Box {...toNext} state="error">
  {@render renderChildren?.()}
</Box>
